import { render, staticRenderFns } from "./QuestionBankPage.vue?vue&type=template&id=74124c67"
import script from "./QuestionBankPage.vue?vue&type=script&lang=ts"
export * from "./QuestionBankPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports